const routes = [
  {
    index: true,
    label: 'Sam Cong',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Experience',
    path: '/experience',
  },
  {
    label: 'Skills',
    path: '/skills',
  },
  {
    label: 'Publications',
    path: '/publications',
  },
  {
    label: 'Blogs',
    path: '/blogs',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
  {
    label: 'Life',
    path: '/life',
  },
  {
    label: 'Photography',
    path: '/photography',
  },
];

export default routes;
